/**
 * Count-up animation for numeric-highlighted block.
 *
 * Observes `.stat-highlighted-value` elements with IntersectionObserver.
 * When one scrolls into view, the `.numeric[data-value]` child animates
 * from 0 to its target value using requestAnimationFrame + easeOutCubic.
 *
 * Prefix/suffix are rendered by their own sibling spans — this script
 * only animates the number inside `.numeric`.
 *
 * No Vue dependency — vanilla JS, self-initializing.
 */

var DURATION = 1200;

function easeOutCubic(t) {
  return 1 - Math.pow(1 - t, 3);
}

function formatNumber(num, decimals) {
  return Number(num).toLocaleString("en-US", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

function getDecimals(target) {
  if (target === Math.round(target)) return 0;
  var str = String(target);
  var dot = str.indexOf(".");
  return dot === -1 ? 0 : str.length - dot - 1;
}

function runCountUp(el, target) {
  var decimals = getDecimals(target);
  var start = performance.now();

  function step(now) {
    var progress = Math.min((now - start) / DURATION, 1);
    var eased = easeOutCubic(progress);
    var current = progress < 1 ? target * eased : target;

    el.textContent = formatNumber(current, decimals);

    if (progress < 1) {
      el._countUpRafId = requestAnimationFrame(step);
    } else {
      el._countUpRafId = null;
    }
  }

  // Cancel any previous animation
  if (el._countUpRafId) {
    cancelAnimationFrame(el._countUpRafId);
  }

  el.textContent = formatNumber(0, decimals);
  el._countUpRafId = requestAnimationFrame(step);
}

function initCountUp() {
  var valueElements = document.querySelectorAll(".stat-highlighted-value");

  if (!valueElements.length) return;

  valueElements.forEach(function (container) {
    var numericEl = container.querySelector(".numeric");

    if (!numericEl) return;

    var raw = numericEl.textContent.replace(/,/g, "");
    var target = parseFloat(raw);

    if (isNaN(target)) return;

    runCountUp(numericEl, target);
  });
}

// Initialize when DOM is ready — handles both sync and async script loading.
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initCountUp);
} else {
  // DOM already parsed; run on next tick to ensure Nunjucks content is rendered.
  setTimeout(initCountUp, 0);
}
